import React, { useState } from 'react';
import MuiExpandedMoreIcon from '@material-ui/icons/ExpandMoreOutlined';
import LabelAccounts from './LabelAccounts';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';

export default function LabelRow({ label }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <MuiTableRow>
        <MuiTableCell>{label.name}</MuiTableCell>
        <MuiTableCell align="right">
          <MuiExpandedMoreIcon
            style={{ cursor: 'pointer', transform: `${open ? 'scaleY(-1)' : 'scaleY(1)'}` }}
            onClick={() => setOpen(!open)}
          />
        </MuiTableCell>
      </MuiTableRow>
      {open && <LabelAccounts accounts={label.recoupAccounts} isOpen={open} />}
    </>
  );
}
